import React, { useState } from 'react';
import './verify-user.container.sass';
import { useParams } from 'react-router-dom';
import { Input } from '../../../components/interface/input/input';
import { useFormik } from 'formik';
import { ApiService } from '../../../services/api/api.service';
import { Button } from '../../../components/interface/button/button';
import { toast } from 'react-toastify';
import { Config } from '../../../config/config';

export const VerifyUserContainer = () => {

  const {vendorId, userToken, vendorToken} = useParams();
  const [isSaved, setSaved] = useState(false);
  const formik = useFormik({
    initialValues: {
      password: ''
    },
    onSubmit: values => {
      ApiService.pureInstance()
        .post(`/vendor/user-verify/verify-user/${vendorId}`, {vendorToken, userToken, password: values.password})
        .then(() => {
          setSaved(true);
        }, () => {
          toast.error('Coś poszło nie tak : (');
        });
    }
  });

  const renderForm = () => {
    return <form className='vv-verify-user-container__form' onSubmit={formik.handleSubmit}>
      <Input type='password'
             placeholder='Password'
             name='password'
             id='password'
             onChange={formik.handleChange}
             value={formik.values.password}/>
      <Button text={'USTAW HASŁO!'} type='submit'/>
    </form>;
  };

  const renderSuccessMessage = () => {
    return <div className='vv-verify-user-container__success-container'>
      <h1>Pobierz Aplikację!</h1>
      <a href={Config.urls.waiterGoogleStoreUrl} target='_blank' rel='noreferrer'>Google Play</a>
      <a href={Config.urls.waiterIosStoreUrl} target='_blank' rel='noreferrer'>App Store</a>
    </div>;
  };

  return (
    <div className='vv-verify-user-container'>
      {isSaved ? renderSuccessMessage() : renderForm()}
    </div>
  );
};
